/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Have_AccountInputs */

const en_auth_signup_have_account = /** @type {(inputs: Auth_Signup_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

const pl_auth_signup_have_account = /** @type {(inputs: Auth_Signup_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masz już konto?`)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Auth_Signup_Have_AccountInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_have_account = /** @type {((inputs?: Auth_Signup_Have_AccountInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Have_AccountInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_have_account(inputs)
	return en_auth_signup_have_account(inputs)
});